import ItemEditView from './ItemEditView'
import ItemListView from './ItemListView'
import Quill from './elements/quilljs/Quill'

export default {
  ItemEditView,
  ItemListView,
  Quill
}
